import { UtilsService } from '../../../core/services/utils.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Denounce } from '../../../core/models/denounce.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { AppState } from '../../../core/state/app.reducer';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { finalize } from 'rxjs/operators';

import * as fromComplaintsSelector from '../../home/state/complaints.selectors';
import * as fromComplaintsActions from '../../home/state/complaints.actions';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../../core/services/user.service';
import { ComplaintConfirmationDeleteComponent } from '../../../components/modals/complaint-confirmation-delete/complaint-confirmation-delete.component';
import { ComplaintsService } from '../../../core/services/complaints.service';
import {
	linesName,
	typesComplaint,
	typeComplaintDict,
	placeComplaintDict,
	placeComplaint,
} from '../../../../assets/complaintsDetail/complaintsInfo';
import {
	MatDateRangePicker,
	MatDatepickerInputEvent,
} from '@angular/material/datepicker';

import { formatDistanceToNow } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { Chart } from 'chart.js';
import { CheckinService } from '../../../core/services/checkin.service';

const _ = require('lodash');

@Component({
	selector: 'app-emergencies-list',
	templateUrl: './emergencies-list.component.html',
	styleUrls: ['./emergencies-list.component.scss'],
})
export class EmergenciesListComponent implements OnInit {
	typesComplaint: string[] = typesComplaint;
	typeComplaintDict = typeComplaintDict;
	placeComplaintDict = placeComplaintDict;
	placeComplaint = placeComplaint;
	linesName: string[] = linesName;
	listsSublocalitys: string[] = [];
	created_at_from_date_complaint: any;
	created_at_to_date_complaint: any;
	user_id_complaint: any;

	searchFilter: FormGroup;

	finishedStatus = false;
	selectedOption = 'Todos';
	public currentYearDate = new Date();
	public currentYear = this.currentYearDate.getFullYear();
	public lastTwoWeeks: Date = null;
	public initialDate: Date = null;
	public lastWeek: Date | String = null;
	public endDate: Date = null;
	public barChartLabels = [`Todos os casos`];
	public selectedLabel = 'Todos';

	public showFilters: boolean = false;

	setShowFilters = (value: boolean) => (this.showFilters = value);

	closeModal(event: MouseEvent): void {
		if (event.target === event.currentTarget) {
			this.setShowFilters(false);
		}
	}

	@ViewChild(MatDateRangePicker) dateRangePicker: MatDateRangePicker<Date>;
	startDate: Date;
	finishDate: Date;

	public from: Date = null;
	public to: Date = null;

	public minDate: Date;
	public maxDate: Date;

	loadFilter: Boolean;
	public currentDate: any;

	user = {
		phone: '',
		email: '',
		role: '',
		gender: '',
		name: '',
	};

	private isUserSuper: Boolean;
	denounces: Denounce[] = [];
	searchForm: FormGroup;
	complaints: Denounce;
	users: [any?] = [];
	homeDenounces;

	checkinData: any;

	usuariosReicidencias = [];

	loading$: Observable<boolean>;
	loading = true;
	todos = 'todos';
	displayedColumns: string[] = [' ', 'sublocality', 'place', 'type'];

	dataSource: MatTableDataSource<any>;

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	dataSourceDenounces: MatTableDataSource<any>;

	constructor(
		private activeRoute: ActivatedRoute,
		public utilsService: UtilsService,
		private store: Store<AppState>,
		public dialog: MatDialog,
		private fb: FormBuilder,
		private router: Router,
		private toastr: ToastrService,
		private userService: UserService,
		private complaintsService: ComplaintsService,
		private checkinService: CheckinService,
		private paginatorTranslator: MatPaginatorIntl
	) {}

	getTimeAgo(datetime): string {
		const date = new Date(datetime);

		const distance = formatDistanceToNow(date, {
			addSuffix: true,
			locale: ptBR,
		});

		return distance;
	}

	openInformationEvent(e) {
		let versionClicked = e.currentTarget.classList[2];
		let elements = document.querySelectorAll(`.${versionClicked}`);

		elements[2]?.classList.toggle('show');
		elements[1]?.classList.toggle('rotate');
		elements[0]?.classList.toggle('expand-filter');
		this.definirValoresPadroes();
	}

	ngOnInit(): void {
		this.translateTable();

		this.month = this.getCurrentMonth();

		this.searchFilter = new FormGroup({
			typeComplaint: new FormControl(['Todos']),
			busLine: new FormControl(),
			ocurrenceDate: new FormControl(),
			placeComplaint: new FormControl(),
			sublocalityComplaint: new FormControl(),
			genderComplaint: new FormControl(),
		});

		this.drawCheckinChart();
		this.drawEmergenciesChart();
		this.queryComplaints();
		this.initPassForm();

		this.definirValoresPadroes();

		this.activeRoute.params.subscribe((params) => {
			this.homeDenounces = params;
		});
		this.isUserSuper = Boolean(localStorage.getItem('superUser'));
		this.getUser();
	}

	seeDetails(id): void {
		this.router.navigate(['/home/ocurrences-details', id]);
	}

	public onInitialDateChange(event: MatDatepickerInputEvent<Date>): void {
		this.initialDate = event.value;
		this.created_at_from_date_complaint = this.initialDate;
		this.barChartLabels = [
			`${this.formatarDataBrasileira(
				this.initialDate
			)} - ${this.formatarDataBrasileira(this.endDate)}`,
		];
		this.selectedLabel = this.barChartLabels[0];
	}

	public onEndDateChange(event: MatDatepickerInputEvent<Date>): void {
		this.endDate = event.value;
		this.created_at_to_date_complaint = this.endDate;
		this.barChartLabels = [
			`${this.formatarDataBrasileira(
				this.initialDate
			)} - ${this.formatarDataBrasileira(this.endDate)}`,
		];
		this.selectedLabel = this.barChartLabels[0];

		if (this.initialDate != null && this.endDate != null) {
			this.from = new Date(
				this.initialDate.getFullYear(),
				this.initialDate.getMonth(),
				this.initialDate.getDate(),
				0,
				0,
				0
			);
			this.to = new Date(
				this.endDate.getFullYear(),
				this.endDate.getMonth(),
				this.endDate.getDate(),
				0,
				0,
				0
			);
			this.queryComplaints();
		}
	}

	initPassForm(): void {
		this.searchForm = this.fb.group({
			search: [''],
		});
	}

	filterComplaint(): void {
		const filter = this.searchForm.value.search;
		this.dataSourceDenounces.filter = filter.toLowerCase();
	}

	getComplaints(): void {
		this.store
			.pipe(select(fromComplaintsSelector.selectComplaintsEntities))
			.subscribe((complaints) => {
				this.denounces = [...complaints];
				this.dataSource = new MatTableDataSource<any>(this.denounces);
				this.dataSourceDenounces = new MatTableDataSource<any>(this.denounces);
				this.dataSourceDenounces.paginator = this.paginator;
				complaints.forEach((denounce: any) => {
					this.listsSublocalitys.push(denounce.sublocality);
					this.listsSublocalitys = removeDuplicates(this.listsSublocalitys);
				});
			});

		this.loading$ = this.store.pipe(
			select(fromComplaintsSelector.selectLoading)
		);
	}

	private portugueseRangeLabel(
		page: number,
		pageSize: number,
		length: number
	): string {
		if (length === 0 || pageSize === 0) {
			return `0 de ${length}`;
		}

		length = Math.max(length, 0);

		const startIndex = page * pageSize;

		const endIndex =
			startIndex < length
				? Math.min(startIndex + pageSize, length)
				: startIndex + pageSize;

		return `${startIndex + 1} - ${endIndex} de ${length}`;
	}

	private translateTable() {
		this.paginatorTranslator.itemsPerPageLabel = 'Itens por página:';
		this.paginatorTranslator.nextPageLabel = 'Página seguinte';
		this.paginatorTranslator.previousPageLabel = 'Página anterior';
		this.paginatorTranslator.firstPageLabel = 'Primeira página';
		this.paginatorTranslator.lastPageLabel = 'Última página';
		this.paginatorTranslator.getRangeLabel = this.portugueseRangeLabel;
	}

	private updateComplaintOnStore(): void {
		this.store.dispatch(fromComplaintsActions.loadComplaints());
	}

	public deleteComplaint(denounce: any): void {
		this.complaintsService
			.deleteComplaint(denounce._id)
			.subscribe()
			.add(() => {
				this.updateComplaintOnStore(); // update list complaint
				this.toastr.success('Denúncia deletada com sucesso!');
			});
	}
	public deleteComplaintFunc(data): void {
		const dialog = this.dialog.open(ComplaintConfirmationDeleteComponent, {
			panelClass: 'media-modal',
			width: '40%',
		});

		dialog.afterClosed().subscribe((response) => {
			if (response === true) {
				this.deleteComplaint(data);
			}
		});
	}

	changeTable(finishedStatus: boolean) {
		this.finishedStatus = finishedStatus;
		this.queryComplaints();
	}

	getUser(): void {
		this.userService.getSelfUserOp().subscribe((userAtt) => {
			userAtt.UserAttributes.forEach((att) => {
				if (att.Name === 'phone_number') {
					this.user.phone = att.Value;
				} else if (att.Name === 'name') {
					this.user.name = att.Value;
				} else if (att.Name === 'gender') {
					this.user.gender = att.Value;
				} else if (att.Name === 'email') {
					this.user.email = att.Value;
				} else if (att.Name === 'custom:role') {
					this.user.role = att.Value;
				}
			});
			this.loading$ = this.store.pipe(
				select(fromComplaintsSelector.selectLoading)
			);
		});
	}

	definirValoresPadroes(): void {
		this.searchFilter!.controls['typeComplaint']!.setValue(['Todos']);
		this.searchFilter!.controls['busLine']!.setValue('Todos');
		this.searchFilter!.controls['placeComplaint']!.setValue('Todos');
		this.searchFilter!.controls['sublocalityComplaint']!.setValue('Todos');
		this.searchFilter!.controls['ocurrenceDate']!.setValue('Todos');
		this.searchFilter!.controls['genderComplaint']!.setValue('Todos');
		this.created_at_from_date_complaint = null;
		this.created_at_to_date_complaint = null;
	}

	limparFiltros(): void {
		this.definirValoresPadroes();
		this.queryComplaints();
		this.showFilters = false;
	}

	capturarID(id): void {
		this.user_id_complaint = id;
		this.queryComplaints();
	}

	queryComplaints(): void {
		this.loading = true;

		this.complaintsService
			.getEmergencies(this.finishedStatus ? 'COMPLETE' : 'INCOMPLETE')
			.pipe(
				finalize(() => {
					this.loading = false;
				})
			)
			.subscribe((res: any) => {
				const emergencies = res.complaints;

				this.denounces = [...emergencies];
				this.dataSource = new MatTableDataSource<any>(emergencies);
				this.dataSourceDenounces = new MatTableDataSource<any>(emergencies);
				this.dataSourceDenounces.paginator = this.paginator;
				emergencies.forEach((emergency: any) => {
					this.listsSublocalitys.push(emergency.sublocality);
					this.listsSublocalitys = removeDuplicates(this.listsSublocalitys);
				});
			});
	}

	formatarDataBrasileira(data) {
		if (data) {
			const dia = String(data.getDate()).padStart(2, '0');
			const mes = String(data.getMonth() + 1).padStart(2, '0');
			const ano = data.getFullYear();
			return `${dia}/${mes}/${ano}`;
		} else {
			return '';
		}
	}

	month: string;
	getCurrentMonth() {
		const months = [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro',
		];

		const date = new Date();
		const month = months[date.getMonth() - 1];

		return month;
	}

	weeklyEmergencies: number;
	emergencyChartConfig = {
		data: [],
		labels: _.range(1, this.getDaysOfLastMonth() + 1),
		// backgtound transparent, line purple
		colors: [{ backgroundColor: 'rgba(0,0,0,0)', borderColor: '#5B43D9' }],
	};

	public options = {
		responsive: true,
		maintainAspectRatio: false,
		legend: {
			display: false,
			onClick: null, // Impedir que a legenda seja clicável
		},
		layout: {
			padding: 20,
		},
		scales: {
			xAxes: [
				{
					display: false,
					id: 'x',
					ticks: {
						padding: 16,
					},
					gridLines: {
						color: 'rgba(229,222,255)', // Cor do grid x
						borderDash: [10, 5], // Padrão de traço (5 pixels sólidos, 5 pixels vazios)
						borderDashOffset: 10, // Deslocamento do padrão de traço
						drawBorder: false, // Não desenhar a borda do gráfico
						//drawOnChartArea: false, // Não desenhar sobre a área do gráfico
						drawTicks: false, // Não desenhar os ticks,
						zeroLineColor: 'rgba(229,222,255)', // Cor da linha zero
						zeroLineBorderDash: [10, 5], // Padrão de traço da linha zero
						zeroLineBorderDashOffset: 10,
						tickMarkLength: 50,
					},
				},
			],
			yAxes: [
				{
					id: 'y',
					ticks: {
						fontColor: '#938F94',
						padding: 16,
					},
					gridLines: {
						color: 'rgba(229,222,255)', // Cor do grid x
						borderDash: [10, 5], // Padrão de traço (5 pixels sólidos, 5 pixels vazios)
						borderDashOffset: 10, // Deslocamento do padrão de traço
						drawBorder: false, // Não desenhar a borda do gráfico
						//drawOnChartArea: false, // Não desenhar sobre a área do gráfico
						drawTicks: false, // Não desenhar os ticks,
						zeroLineColor: 'rgba(229,222,255)', // Cor da linha zero
						zeroLineBorderDash: [10, 5], // Padrão de traço da linha zero
						zeroLineBorderDashOffset: 10,
						tickMarkLength: 50, // Deslocamento do padrã
					},
				},
			],
		},
		elements: {
			point: {
				radius: 5, // Tamanho dos pontos de dados
				hoverRadius: 8, // Tamanho dos pontos de dados ao passar o mouse
			},
			line: {
				tension: 0,
				borderDash: [0, 0],
			},
		},
	};

	getDaysOfLastMonth() {
		const date = new Date();
		const days = new Date(date.getFullYear(), date.getMonth(), 0).getDate();

		return days;
	}

	drawEmergenciesChart() {
		this.complaintsService.getEmergenciesStaticData().subscribe((res: any) => {
			this.weeklyEmergencies = res.last_week.count;

			const frequency = res.last_month.emergency_frequency;

			const days = this.getDaysOfLastMonth();
			const data = [];

			for (let day in _.range(days)) {
				data.push(frequency.filter((f) => f.day == day)[0]?.count || 0);
			}

			this.emergencyChartConfig.data = [
				{
					data,
					label: this.month,
					fill: true,
					borderWidth: 2,
					pointRadius: 2,
					borderColor: '5B43D9',
				},
			];
		});
	}

	checkins = [];

	drawCheckinChart() {
		this.checkinService.getCheckins().subscribe((res: any) => {
			const checkins = res.locations_count;
			const colors = ['#180064', '#2C009E', '#5B43D9']; // , '#5CDBBD'
			this.checkins = Object.keys(checkins);

			var data = {
				labels: Object.keys(checkins),
				datasets: [
					{
						backgroundColor: colors,
						data: Object.keys(checkins).map((checkin) => {
							return checkins[checkin];
						}),
					},
				],
			};

			const canvas = document.getElementById(
				'checkinChart'
			) as HTMLCanvasElement;
			const ctx = canvas.getContext('2d');

			var myChart = new Chart(ctx, {
				type: 'bar',
				data: data,
				options: {
					responsive: true,

					legend: {
						display: false,
						position: 'bottom', // Posição da legenda
						align: 'center', // Alinhamento da legenda
						labels: {
							usePointStyle: false, // Usar estilo de ponto (cor do item da legenda)
							boxWidth: 12, // Tamanho da caixa da legenda
							fontColor: '#938F94', // Cor da fonte da legenda
						},
					},
					scales: {
						xAxes: [
							{
								ticks: {
									display: false,
								},
								gridLines: {
									display: false,
								},
							},
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									fontColor: '#938F94',
								},
								gridLines: {
									color: 'rgba(229,222,255)',
									borderDash: [10, 5],
									borderDashOffset: 10,
									drawBorder: false,
									drawTicks: false,
									zeroLineColor: 'rgba(229,222,255)',
									zeroLineBorderDash: [10, 5],
									zeroLineBorderDashOffset: 10,
								},
							},
						],
					},
				},
			});
		});
	}
}

function removeDuplicates(strings) {
	const uniqueStrings = [];

	for (const str of strings) {
		if (!uniqueStrings.includes(str)) {
			uniqueStrings.push(str);
		}
	}

	return uniqueStrings;
}

function convertToPythonDatetime(date) {
	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const day = date.getDate().toString().padStart(2, '0');
	const hours = date.getHours().toString().padStart(2, '0');
	const minutes = date.getMinutes().toString().padStart(2, '0');
	const seconds = date.getSeconds().toString().padStart(2, '0');

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
